import _ from 'lodash';
import {all, select, takeLatest} from 'redux-saga/effects';

import {updateCurrentUrlParams} from 'utils/urls';

import {STORE_PARAMS_IN_URL} from './';

function* storeParamsInUrlWorker(action) {
  const {selector, builder} = action.payload;

  const state = yield select();
  const stateParams = selector(state);
  const params = builder(stateParams);

  updateCurrentUrlParams(params);
}

function* urlsSaga() {
  yield all([takeLatest(STORE_PARAMS_IN_URL, storeParamsInUrlWorker)]);
}

export default urlsSaga;
